import template from './travel-expense-actuals.html';
import controller from './travel-expense-actuals.controller';

let travelExpenseActualsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default travelExpenseActualsComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/travel-expense-actuals/travel-expense-actuals.component.js